import type { ZoneResponse } from 'api/__GENERATED';
import * as R from 'remeda';

import { toProductivityGoal } from './toProductivityGoal';

// Maps a single Zone DTO from the generated API client onto the normalized
// `Data.Zone` shape. `subZoneIds` is still nullable in the DTO — default to
// an empty array. `targets` is built from `productivityGoals` using the same
// pipeline as `toSubZone`: map, drop goals without `validFrom`, sort by day.
// `productivityNumbers` and `percentOfTotalRows` are not part of `Data.Zone`
// and are intentionally ignored here.
function toZone(dto: ZoneResponse) {
  const { id, name, description, subZoneIds, productivityGoals } = dto;

  const targets = R.pipe(
    productivityGoals ?? [],
    R.map(toProductivityGoal),
    R.filter(R.isDefined),
    R.sortBy((target) => target.date.id),
  );

  const zone: Data.Zone = {
    id,
    name,
    description: description ?? '',
    subZoneIds: subZoneIds ?? [],
    targets,
  };

  return zone;
}

export { toZone };
